// 组件路由
import Layout from '@/view/layout' // 主框架

export default {
  path: '/customer',
  component: Layout,
  children: [
    {
      path: 'potentialCustomer',
      component: () =>
        import(
          /* webpackChunkName: "customer-potentialCustomer" */ '@/view/customer/potentialCustomer'
        ),
      name: '潜客'
    },
    {
      path: 'index',
      component: () => import(/* webpackChunkName: "customer-index" */ '@/view/customer/index'),
      name: '客户管理'
    },
    {
      path: 'index/:id',
      component: () => import(/* webpackChunkName: "customer-detail" */ '@/view/customer/detail'),
      name: '客户详情'
    },
    {
      path: 'statistics',
      component: () =>
        import(/* webpackChunkName: "customer-statistics" */ '@/view/performance/customerNumber'),
      name: '客户统计'
    },
    {
      path: 'label',
      component: () => import(/* webpackChunkName: "customer-label" */ '@/view/customer/label'),
      name: '标签管理'
    }
  ]
}
